import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { FeaturesDataDispatcher } from '../features-data/features-data.dispatcher';
import { ItemDataBuilder } from './item-data.builder';
import { ItemDataService } from './item-data.service';
import { Item } from './item.model';
import { EntityDataEffects } from '../entity-data/entity-data.effects';
import { IState } from './item-data.reducer';
import { TranslateService } from '@ngx-translate/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { DialogService } from '../dialog/dialog.service';
import { NavigationService } from '../navigation/navigation.service';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { FeaturesDataStore } from '../features-data/features-data.store';
import { LocalStorageService } from '../browser-manager-data/local-storage.service';
import { ItemDataStore } from './item-data.store';
import { AppStore } from '../../store';

@Injectable()
export class ItemDataEffects extends EntityDataEffects<IState, Item> {
  constructor(
    itemDataService: ItemDataService,
    itemDataStore: ItemDataStore,
    itemDataBuilder: ItemDataBuilder,
    actions: Actions,
    appStore: AppStore,
    translateService: TranslateService,
    globalBannerService: GlobalBannerService,
    dialogService: DialogService,
    navigationService: NavigationService,
    settingsDataStore: SettingsDataStore,
    featuresDataStore: FeaturesDataStore,
    localStorageService: LocalStorageService,
    featuresDataDispatcher: FeaturesDataDispatcher
  ) {
    super(
      actions,
      appStore,
      itemDataService,
      itemDataStore,
      itemDataBuilder,
      settingsDataStore,
      featuresDataStore,
      translateService,
      globalBannerService,
      dialogService,
      navigationService,
      localStorageService,
      featuresDataDispatcher
    );
  }

  @Effect() loadSearchParams = this.loadSearchParams;
  @Effect() persistSearchParams = this.persistSearchParams;
  @Effect() fetchList = this.fetchList;
  @Effect() searchList = this.searchList;
  @Effect() fetchNextPage = this.fetchNextPage;
  @Effect() getEntityById = this.getEntityById;
  @Effect() saveNewEntity = this.saveNewEntity;
  @Effect() saveNewEntityError = this.saveNewEntityError;
  @Effect() updateEntity = this.updateEntity;
  @Effect() createNewEditingEntity = this.createNewEditingEntity;
  @Effect() refreshEditingEntity = this.refreshEditingEntity;
  @Effect() setEditingEntityContent = this.setEditingEntityContent;
  @Effect() setEditingEntityProperties = this.setEditingEntityProperties;
  @Effect() setEditingEntityField = this.setEditingEntityField;
  @Effect() saveEditingEntity = this.saveEditingEntity;
  @Effect() saveExistingEntityError = this.saveExistingEntityError;
  @Effect() saveEntityStore = this.saveEntityStore;
  @Effect() deleteEntityStore = this.deleteEntityStore;
  @Effect() saveEntityToNetwork = this.saveEntityToNetwork;
  @Effect() deleteEntityNetwork = this.deleteEntityNetwork;
  @Effect() addToLimitedSelectedList = this.addToLimitedSelectedList;
  @Effect() deleteSelectedEntities = this.deleteSelectedEntities;
  @Effect() batchDeleteEntityStore = this.batchDeleteEntityStore;
  @Effect() batchDeleteEntityNetwork = this.batchDeleteEntityNetwork;
  @Effect() batchSaveEntityStore = this.batchSaveEntityStore;
}
